import Client from "../client";
import { buildODataQueryString } from "../odata";
import {
  EndpointsParams,
  ExportResponse,
  InboxesParams,
  RequestOptions,
  UsersParams,
} from "../types";

export default class ExportController {
  #client: Client;

  constructor(client: Client) {
    this.#client = client;
  }

  async downloadEndpointsCsv(
    { query }: EndpointsParams,
    options: RequestOptions = {},
  ): Promise<ExportResponse> {
    const odataQuery = buildODataQueryString(query);
    const response = await this.#client.requestWithAuth(
      `/export/scm/endpoint${odataQuery}`,
      {
        method: "POST",
        ...options,
      },
    );

    return await response.json();
  }

  async downloadUsersCsv(
    { query }: UsersParams,
    options: RequestOptions = {},
  ): Promise<ExportResponse> {
    const odataQuery = buildODataQueryString(query);

    const response = await this.#client.requestWithAuth(
      `/export/scm/user${odataQuery}`,
      {
        method: "POST",
        ...options,
      },
    );

    return await response.json();
  }

  async downloadInboxesCsv(
    { query }: InboxesParams,
    options: RequestOptions = {},
  ): Promise<ExportResponse> {
    const response = await this.#client.requestWithAuth(
      `/export/scm/inbox${buildODataQueryString(query)}`,
      {
        method: "POST",
        ...options,
      },
    );

    return await response.json();
  }
}
